import React from 'react';
import { ArrowLeft } from 'lucide-react';
import Footer from '../components/Footer';

const PolitiqueConfidentialite: React.FC = () => {
  return (
    <>
    <div className="min-h-screen bg-stone-50">
      <div className="container-max section-padding py-12">
        <a 
          href="/"
          className="inline-flex items-center space-x-2 text-wood-600 hover:text-wood-700 mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Retour à l'accueil</span>
        </a>

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-bold text-stone-900 mb-8">
            Politique de Confidentialité
          </h1>

          <div className="space-y-8 text-stone-700">
            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">1. Introduction</h2>
              <p className="leading-relaxed">
                ARS AGENCEMENT accorde une grande importance à la protection de vos données personnelles. 
                Cette politique de confidentialité a pour but de vous informer sur la manière dont nous collectons, 
                utilisons et protégeons vos informations personnelles conformément au Règlement Général sur la 
                Protection des Données (RGPD).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">2. Responsable du traitement</h2>
              <p className="mb-2">
                <strong>Raison sociale :</strong> ARS AGENCEMENT
              </p>
              <p className="mb-2">
                <strong>Adresse :</strong> 2 Rue Joseph le Brix, 56400 Plougoumelen
              </p>
              <p className="mb-2">
                <strong>Email :</strong> <a href="mailto:contact@ars-agencement.bzh" className="text-wood-600 hover:text-wood-700">contact@ars-agencement.bzh</a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">3. Données collectées</h2>
              <p className="leading-relaxed mb-4">
                Nous collectons les données personnelles que vous nous fournissez directement lors de :
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>La prise de contact via le formulaire de contact</li>
                <li>Les demandes de devis</li>
                <li>Les appels téléphoniques</li>
                <li>Les échanges par email</li>
              </ul>
              <p className="mt-4 leading-relaxed">
                <strong>Types de données collectées :</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone</li>
                <li>Adresse postale (si nécessaire pour le projet)</li>
                <li>Informations relatives à votre projet</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">4. Finalités du traitement</h2>
              <p className="leading-relaxed mb-4">
                Vos données personnelles sont collectées pour les finalités suivantes :
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Répondre à vos demandes de contact et de devis</li>
                <li>Gérer la relation client</li>
                <li>Effectuer le suivi de votre projet</li>
                <li>Améliorer nos services</li>
                <li>Respecter nos obligations légales et réglementaires</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">5. Base légale du traitement</h2>
              <p className="leading-relaxed">
                Le traitement de vos données personnelles repose sur :
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li><strong>Votre consentement :</strong> lorsque vous nous contactez via le formulaire</li>
                <li><strong>L'exécution d'un contrat :</strong> pour la réalisation de devis et de prestations</li>
                <li><strong>Notre intérêt légitime :</strong> pour améliorer nos services</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">6. Durée de conservation</h2>
              <p className="leading-relaxed">
                Vos données personnelles sont conservées pendant la durée nécessaire aux finalités pour lesquelles 
                elles ont été collectées :
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li><strong>Demandes de devis non abouties :</strong> 3 ans</li>
                <li><strong>Clients :</strong> durée de la relation commerciale + 5 ans (obligations comptables)</li>
                <li><strong>Prospects :</strong> 3 ans à compter du dernier contact</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">7. Destinataires des données</h2>
              <p className="leading-relaxed">
                Vos données personnelles sont destinées à :
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>ARS AGENCEMENT et ses collaborateurs</li>
                <li>Nos sous-traitants techniques (hébergeur OVH)</li>
                <li>Les autorités légales si requis par la loi</li>
              </ul>
              <p className="mt-4 leading-relaxed">
                Nous ne vendons ni ne louons vos données personnelles à des tiers.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">8. Sécurité des données</h2>
              <p className="leading-relaxed">
                Nous mettons en œuvre toutes les mesures techniques et organisationnelles appropriées pour protéger 
                vos données personnelles contre la destruction accidentelle ou illicite, la perte accidentelle, 
                l'altération, la diffusion ou l'accès non autorisé.
              </p>
              <p className="mt-4 leading-relaxed">
                <strong>Hébergement sécurisé :</strong> Notre site est hébergé par OVH, qui garantit un niveau 
                de sécurité conforme aux standards de l'industrie.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">9. Vos droits</h2>
              <p className="leading-relaxed mb-4">
                Conformément au RGPD, vous disposez des droits suivants :
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Droit d'accès :</strong> obtenir la confirmation que vos données sont traitées et y accéder</li>
                <li><strong>Droit de rectification :</strong> corriger vos données inexactes ou incomplètes</li>
                <li><strong>Droit à l'effacement :</strong> supprimer vos données dans certaines conditions</li>
                <li><strong>Droit à la limitation :</strong> limiter le traitement de vos données</li>
                <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
                <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
                <li><strong>Droit de retirer votre consentement :</strong> à tout moment</li>
              </ul>
              <p className="mt-4 leading-relaxed">
                Pour exercer vos droits, contactez-nous à : <a href="mailto:contact@ars-agencement.bzh" className="text-wood-600 hover:text-wood-700">contact@ars-agencement.bzh</a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">10. Cookies</h2>
              <p className="leading-relaxed">
                Notre site utilise des cookies essentiels au fonctionnement du site. Aucun cookie de traçage 
                publicitaire n'est utilisé. Vous pouvez configurer votre navigateur pour refuser les cookies, 
                mais certaines fonctionnalités du site pourraient ne pas fonctionner correctement.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">11. Modifications</h2>
              <p className="leading-relaxed">
                Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. 
                Toute modification sera publiée sur cette page avec une date de mise à jour.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">12. Réclamation</h2>
              <p className="leading-relaxed">
                Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation 
                auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés) :
              </p>
              <p className="mt-4">
                <strong>Site web :</strong> <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-wood-600 hover:text-wood-700">www.cnil.fr</a>
              </p>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-stone-200">
            <p className="text-sm text-stone-500">
              Date de dernière mise à jour : Juin 2026
            </p>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default PolitiqueConfidentialite;
